<app-ehe-header [auth]="true" [wellness]="true"></app-ehe-header>
<section class="referral-wrapper general-wrapper enable-wellness">
	<div class="container">
		<div class="row">
			<div class="col-md-3 text-18 g-left hide-on-small">
				<ul class="global-sidebar-nav">
					<li
						*ngFor="let nav of navItems; let navIndex = index"
						[class.active]="nav.expanded"
						routerLinkActive="active">
						<span class="nav-item" (click)="makeNavItemActive(navIndex)" routerLink="{{ nav.route }}">
							{{ nav.title }}
						</span>
						<ul *ngIf="nav.subNavItems && nav.subNavItems.length !== 0">
							<li
								*ngFor="let subNavItem of nav.subNavItems; let subNavIndex = index"
								[class.active]="subNavItem.active"
								routerLinkActive="active">
								<span
									class="nav-item"
									(click)="makeSubNavItemActive(navIndex, subNavIndex)"
									routerLink="{{ subNavItem.route }}">
									{{ subNavItem.title }}
								</span>
							</li>
						</ul>
					</li>
				</ul>
				<div class="contact text-14">
					<div>Questions?</div>
					<div class="text-link clickable" (click)="sendMessage()" appEheAnalytics [data]="analyticsData">
						Contact the Referral Team
					</div>
				</div>
			</div>
			<app-responsive-menu
				[menuItems]="sidebarMenu"
				[currentIndex]="selectedIndex"
				class="w-100 hide-on-large"
				(selectedIndex)="getSelectedIndex($event)"></app-responsive-menu>
			<div class="hide-on-large w-100 responsive-sub-menu-wrapper">
				<ul class="global-sidebar-nav global-sidebar-on-small-screen" id="_submenu">
					<li
						class="global-sidebar-on-small-screen-li"
						*ngFor="let menu of navItems[selectedIndex].subNavItems"
						[routerLink]="[menu.route]"
						routerLinkActive="active">
						{{ menu?.title }}
					</li>
				</ul>
			</div>
			<div class="col-md-9 g-right">
				<div class="left-outline">
					<router-outlet></router-outlet>
				</div>
			</div>
		</div>
	</div>
</section>
<app-ehe-spinner></app-ehe-spinner>
<app-ehe-footer [socialNetwork]="true"></app-ehe-footer>
